import { WIDGETS, widgetName } from '@noorview/core';
import { toast } from '../data/store';
import { useStudio } from './store';
import { clipLabel, copyWidgets, getClip, pasteWidgets, setPicking, useClipboard } from './clipboard';

/* The web Studio's copy and paste: the Copy menu, the Paste button and ⌘C / ⌘V. */

const st = () => useStudio.getState();

/** The picked widgets, or the selected one. */
export function copySelected(screen: string) {
  const d = st().design;
  if (!d) return;
  const { picked } = useClipboard.getState();
  const ids = picked.length ? picked : st().selected ? [st().selected!] : [];
  const list = d.widgets.filter((w) => ids.includes(w.id));
  if (!list.length) { toast('Select a widget to copy, or choose Copy all widgets.'); return; }
  copyWidgets(d, list, screen);
  setPicking(false);
  toast(list.length === 1 ? `Copied ${widgetName(list[0]!)}` : `Copied ${list.length} widgets`);
}

export function copyAll(screen: string) {
  const d = st().design;
  const list = d?.widgets.filter((w) => !w.hidden) ?? [];
  if (!d || !list.length) { toast('There are no widgets on this screen to copy.'); return; }
  copyWidgets(d, list, screen);
  setPicking(false);
  toast(`Copied all ${list.length} widget${list.length === 1 ? '' : 's'} from ${screen}`);
}

export function pasteHere(screen: string) {
  const d = st().design, clip = getClip();
  if (!d || !clip) { toast('Copy a widget first, then paste it here.'); return; }
  const { added, skipped } = pasteWidgets(d, clip);
  if (!added.length) { toast('There’s no room on this screen for the copied widgets. Make some space, then paste again.', { bad: true }); return; }
  st().change((x) => ({ ...x, widgets: [...x.widgets, ...added] }));
  setPicking(false);
  st().select(added.length === 1 ? added[0]!.id : null);
  const what = added.length === 1 ? (added[0]!.name || WIDGETS[added[0]!.type].label) : `${added.length} widgets`;
  toast(`Pasted ${what}${clip.from && clip.from !== screen ? ` from ${clip.from}` : ''}${skipped ? `. ${skipped} didn’t fit` : ''}`, { action: { label: 'Undo', run: () => useStudio.getState().undo() } });
}

export const pasteTitle = () => { const c = useClipboard.getState().clip; return c ? `Paste ${clipLabel(c)}${c.from ? ` (copied from ${c.from})` : ''}` : 'Copy widgets first, then paste them here or on another screen'; };
